/**
 * @generated SignedSource<<af42fdfef341116f379538b69888301c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreEditNameScreenMutation$variables = {
  newName: string;
};
export type StoreEditNameScreenMutation$data = {
  readonly store: {
    readonly updateName: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type StoreEditNameScreenMutation = {
  response: StoreEditNameScreenMutation$data;
  variables: StoreEditNameScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newName"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "newName"
          }
        ],
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "updateName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreEditNameScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreEditNameScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea3b4a292e247d5c25e8ebb1459419c7",
    "id": null,
    "metadata": {},
    "name": "StoreEditNameScreenMutation",
    "operationKind": "mutation",
    "text": "mutation StoreEditNameScreenMutation(\n  $newName: String!\n) {\n  store {\n    updateName(name: $newName) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9cd3aa1e3cfeadeb23cb0879c220732";

export default node;
